/**
 * gamesUtils.js
 *
 * Чистые функции для раздела «Игры» — без React, без side effects.
 *
 * Зачем отдельный файл:
 * - filterGames / getGamePreviewUrl используются в нескольких местах.
 * - Легко покрыть тестами (если понадобится).
 * - GamesPage остаётся про orchestration (state, effects, layout).
 */

/**
 * Собирает публичный URL превью игры.
 * Все картинки лежат в public/games_previews/ и отдаются nginx как статика.
 *
 * @param {string} imagePath — имя файла из gamesCatalog (например "hangman-v2.png")
 * @returns {string} путь для src у <img>
 */
export const getGamePreviewUrl = (imagePath) => `/games_previews/${imagePath}`;

/**
 * URL превью для карточки в сетке / mobile.
 * Если задан tile_image_path — используем его (full-bleed без fade под баннер).
 */
export const getGameTilePreviewUrl = (game) =>
  getGamePreviewUrl(game.tile_image_path ?? game.image_path);

/**
 * Фильтрует список игр для SearchBar на странице /service/games.
 *
 * Правила (как было в GamesPage):
 * 1. Игра без index или index <= 0 — не показываем (защита от битых записей).
 * 2. Пустой search — показываем все валидные.
 * 3. Иначе — case-insensitive match по name.
 *
 * @param {Array} games — массив из GAMES_CATALOG (или отсортированная копия)
 * @param {string} searchValue — строка из SearchBar
 * @returns {Array} отфильтрованный список (новый массив, исходный не мутируем)
 */

export const filterGames = (games, searchValue) => {
  const query = (searchValue ?? "").trim().toLowerCase();

  return games.filter((game) => {
    if (!game.index || game.index <= 0) return false;
    if (query === "") return true;
    return game.name.toLowerCase().includes(query);
  });
};

/**
 * Делит отфильтрованный список на featured (баннер) и остальные (сетка).
 * На desktop featured-игра не дублируется в grid.
 *
 * @param {Array} games — результат filterGames()
 * @returns {{ featuredGame: object|undefined, gridGames: Array }}
 */
export const splitFeaturedAndGrid = (games) => ({
  featuredGame: games.find((game) => game.featured),
  gridGames: games.filter((game) => !game.featured),
});
